import { IGlobalEnvironment } from "@interfaces/iEnvironment";

export const globalEnvironment: IGlobalEnvironment = {
	buildDate:'2026-11-05T15:46:51.205Z',
	youtubeCookieNames: ['Youtube Cookies (ytimg)', 'YouTube Video', 'YouTube'],
	treePath: "/live-catalog-public/catalog/{key}/cache/tree_{encoding}.json",
	catalogLogoPath: "/live-catalog-public/catalog/{key}/logo/{size}/{key}.{format}",
	prefetchCatalogPath: "/api/v3/CatalogView/catalogKey/{key}",
	prefetchCatalogDetailsPath: "/api/v3/CatalogView/catalogItemGuid/{guid}/details",
	prefetchWatchlistInforamtionPath: "/api/v3/WatchList/information",
	prefetchCatalogItemMetaPath: "/api/v3/CatalogView/catalogItem/{guid}/meta",
	prefetchCatalogInfoPath: "/api/v3/CatalogView/catalogKey/{key}/meta",
	prefetchSearchTagsPath: "/api/v3/Search/catalogKey/{key}/search?searchTerm=&searchFilter=&pageIndex=0&pageSize=50&maxTeaserLength=0",
	trackIntervalInSec: 5,
	helpdeskHeader: {
		solution: "ADE_FAQ",
		helpId: "180100001"
	},
	helpdeskCM: {
		solution: "ADE_CM",
		helpId: "180500000"
	}
}